import { applyContext } from "../data/contextRouting/APPLY_Context";
import { comContext } from "../data/contextRouting/COM_Context";
import { olbContext } from "../data/contextRouting/OLB_Context";
import { ptaContext } from "../data/contextRouting/PTA_Context";
import { testContext } from "../data/contextRouting/TEST_Context";
import { costcoContext } from "../data/contextRouting/COSTCO_Context";

const SERVICE_NAME = "Context Manager Service";
const DEFAULT = "DEFAULT";

class ContextManagerService {
  channel = "";

  constructor(channelId) {
    this.channel = channelId;
  }

  toString() {
    return {
      Class: SERVICE_NAME,
      ChannelId: this.channel,
    };
  }

  getMapper() {
    let retVal = null;
    switch (this.channel.toLowerCase()) {
      case "com":
        retVal = comContext;
        break;
      case "olb":
        retVal = olbContext;
        break;
      case "apply":
        retVal = applyContext;
        break;
      case "pta":
        retVal = ptaContext;
        break;
      case "testing":
        retVal = testContext;
        break;
      case "costco":
        retVal = costcoContext;
        break;
      default:
        retVal = "Not Found";
        break;
    }
    return retVal;
  }

  Process(pathName, defaultPage, reportData) {
    let tempCategory = null;
    let tempPageKey = null;
    const channelMapperObj = this.getMapper();

    let defaultCategory = DEFAULT;
    let defaultPageKey = DEFAULT;

    if (channelMapperObj != null) {
      const { mappings } = channelMapperObj;
      let itemFound = false;
      if (mappings != null) {
        for (const item of mappings) {
          if (pathName.includes(item.url)) {
            // if the pathName matches the item.url then we have found a match
            // this should set the default category and page key from the item.
            defaultCategory = item.categoryId;
            defaultPageKey = item.page_key;

            // check for generics
            if (item.isGeneric === false) {
              tempCategory = item.categoryId;
              tempPageKey = item.page_key;
              itemFound = true;
            }

            if (item.useDefault) {
              // if userDefaultValues eq true then set the defaultPageKey variable to the
              // value passed in via the props
              tempCategory = defaultCategory;
              tempPageKey = defaultPage;
            }

            if (item.useReportingData === true) {
              const newValues = this.parseReportingData(
                reportData.rawReportData,
                item.reportData
              );
              if (newValues !== null) {
                if (
                  newValues.categoryId !== null &&
                  newValues.categoryId !== ""
                ) {
                  tempCategory = newValues.categoryId;
                }

                if (newValues.pageKey !== null && newValues.pageKey !== "") {
                  tempPageKey = newValues.pageKey;
                }
              }
            }
          }
          if (itemFound) {
            break;
          }
        }
      }
    }
    // set the variables to the default state
    if (tempCategory === null) {
      tempCategory = defaultCategory;
      tempPageKey = defaultPageKey;
    }

    return {
      categoryId: tempCategory,
      pageKey: tempPageKey,
    };
  }

  parseReportingData(reportingData, instructions) {
    let tempCategory = null;
    let tempPageKey = null;

    if (instructions !== null) {
      const { fields } = instructions;
      if (fields !== null) {
        const processedObj = this.processFields(reportingData, fields);
        if (processedObj != null) {
          if (processedObj.categoryId !== null) {
            tempCategory = processedObj.categoryId;
          }
          if (processedObj.pageKey !== null) {
            tempPageKey = processedObj.pageKey;
          }
        }
      }
    }
    return {
      categoryId: tempCategory,
      pageKey: tempPageKey,
    };
  }

  processFields(dataObj, fields) {
    let tempCategory = null;
    let tempPageKey = null;
    let actions = [];
    for (const item of fields) {
      const currentValue = dataObj[item.key];
      let conditionPassed = false;
      const fieldType = item.type;
      // default the field actions to the conditional failActions
      let fieldActions = item.conditional?.failActions || null;
      if (currentValue !== undefined) {
        if (fieldType === "string") {
          conditionPassed = this.processCondition(
            item.conditional,
            currentValue,
            fieldType
          );
        } else if (fieldType === "boolean") {
          conditionPassed = this.processCondition(
            item.conditional,
            currentValue,
            fieldType
          );
        } else if (fieldType === "array") {
          if (currentValue.length > 0) {
            switch (item.indexToProcess) {
              case "ALL":
                // if all add a loop to walk through each element
                break;
              default: // default state assumes that the value is an individual index value
                const index = parseInt(item.indexToProcess);
                const currentItem = currentValue[index];
                // process fields in the given object.
                const processedObj = this.processFields(
                  currentItem,
                  item.fields
                );
                if (processedObj.categoryId != null) {
                  tempCategory = processedObj.categoryId;
                }
                if (processedObj.pageKey != null) {
                  tempPageKey = processedObj.pageKey;
                }
                // replace the field actions with the actions determined by the process Fields
                fieldActions = processedObj.actions;
            }
          }
        }
      }

      if (conditionPassed === true) {
        fieldActions = item.conditional.passActions;
      }

      if (fieldActions !== null) {
        const actionResponse = this.processActions(fieldActions, dataObj);
        if (actionResponse.categoryId != null) {
          tempCategory = actionResponse.categoryId;
        }
        if (actionResponse.pageKey != null) {
          tempPageKey = actionResponse.pageKey;
        }
        for (const newAction of actionResponse.actions) {
          actions.push(newAction);
        }
        if (actionResponse.exitCheck === true) {
          break;
        }
      }
    }

    return {
      categoryId: tempCategory,
      pageKey: tempPageKey,
      actions: actions,
    };
  }

  processActions(itemActions, dataObj) {
    let tempCategory = null;
    let tempPageKey = null;
    let actions = [];
    let exitCheck = false;

    if (itemActions !== null) {
      for (const action of itemActions) {
        let actionTask = action.task;
        if (actionTask === "next") {
          break;
        }
        if (actionTask === "exit") {
          exitCheck = true;
          break;
        }

        const actionType = action.type;
        let value = "";
        if (actionType === "variable") {
          const variableValue = dataObj[action.valueKey];
          if (variableValue !== null && variableValue !== undefined) {
            value = variableValue;
          } else {
            actions.push(action);
            actionTask = "skip";
          }
        } else if (actionType === "value") {
          value = action.valueKey;
        }

        switch (actionTask) {
          case "pageKey":
            tempPageKey = value;
            break;
          case "categoryId":
            tempCategory = value;
            break;
          default:
            break;
        }
      }
    }

    return {
      categoryId: tempCategory,
      pageKey: tempPageKey,
      exitCheck: exitCheck,
      actions: actions,
    };
  }

  processCondition(conditional, currentValue, fieldType) {
    let conditionPassed = false;
    if (conditional != null) {
      const conditionalValue = conditional.value;
      switch (conditional.comparison) {
        case "NOT_EQUALS":
          if (currentValue !== conditionalValue) {
            conditionPassed = true;
          }
          break;
        case "EQUALS":
          if (fieldType === "string") {
            if (currentValue.toLowerCase() === conditionalValue.toLowerCase()) {
              conditionPassed = true;
            }
          } else if (fieldType === "boolean") {
            if (currentValue === conditionalValue) {
              conditionPassed = true;
            }
          }
          break;

        default:
          break;
      }
    }
    return conditionPassed;
  }
}

export default ContextManagerService;
